var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.750000, 0.750000)",
    fill: "#006A35",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2.5 L2.5,19 L16,19 L16,2.5 L2.5,2.5 Z M1.25,0 L17.25,0 C17.9403559,0 18.5,0.559644063 18.5,1.25 L18.5,20.25 C18.5,20.9403559 17.9403559,21.5 17.25,21.5 L1.25,21.5 C0.559644063,21.5 0,20.9403559 0,20.25 L0,1.25 C0,0.559644063 0.559644063,0 1.25,0 Z",
    id: "Path-2-Copy",
    transform: "translate(9.250000, 10.750000) rotate(180.000000) translate(-9.250000, -10.750000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25,6.5 L7.25,6.5 C6.25,6.5 6.25,5 7.25,5 L13.25,5 C14.25,5 14.25,6.5 13.25,6.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25,10.5 L7.25,10.5 C6.25,10.5 6.25,9 7.25,9 L13.25,9 C14.25,9 14.25,10.5 13.25,10.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25,14.5 L7.25,14.5 C6.25,14.5 6.25,13 7.25,13 L13.25,13 C14.25,13 14.25,14.5 13.25,14.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,10.75 C4.19771525,10.75 3.75,10.3022847 3.75,9.75 C3.75,9.19771525 4.19771525,8.75 4.75,8.75 C5.30228475,8.75 5.75,9.19771525 5.75,9.75 C5.75,10.3022847 5.30228475,10.75 4.75,10.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,14.75 C4.19771525,14.75 3.75,14.3022847 3.75,13.75 C3.75,13.1977153 4.19771525,12.75 4.75,12.75 C5.30228475,12.75 5.75,13.1977153 5.75,13.75 C5.75,14.3022847 5.30228475,14.75 4.75,14.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,6.75 C4.19771525,6.75 3.75,6.30228475 3.75,5.75 C3.75,5.19771525 4.19771525,4.75 4.75,4.75 C5.30228475,4.75 5.75,5.19771525 5.75,5.75 C5.75,6.30228475 5.30228475,6.75 4.75,6.75 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.0468199cfba2ef508da37587044e0578.svg";
export { ForwardRef as ReactComponent };